module.exports = __webpack_public_path__ + "img/safety.1ef502c4.png";